/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-icon';
